export default {
  1: {
    label: '未提交'
  },
  2: {
    label: '待复核'
  },
  1073741824: {
    label: '被退回'
  },
  4: {
    label: '已通过'
  }
}



// WEBPACK FOOTER //
// ./src/views/08Operations/02Log/statusMap.js